import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { Check } from "lucide-react"

import { cn } from "@/lib/utils"

const checkedTones = {
  accent: "data-[state=checked]:border-accent data-[state=checked]:bg-accent data-[state=checked]:shadow-glow",
  danger: "data-[state=checked]:border-danger data-[state=checked]:bg-danger data-[state=checked]:shadow-glow-danger",
  jail: "data-[state=checked]:border-jail data-[state=checked]:bg-jail data-[state=checked]:shadow-glow-jail",
};

type CheckboxProps = React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
  tone?: keyof typeof checkedTones;
};

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  CheckboxProps
>(({ className, tone = "accent", ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
"peer pressable relative h-4 w-4 shrink-0 rounded-bar border border-edge-strong bg-track outline-none disabled:cursor-not-allowed disabled:opacity-40",
"data-[state=checked]:text-accent-foreground",
      checkedTones[tone],
      className
    )}
    {...props}
  >
    {/* out of flow on purpose: in flow it only exists while checked, and that
        alone moves the box's baseline and nudges the row it sits in */}
    <CheckboxPrimitive.Indicator
      className={cn("pointer-events-none absolute inset-0 flex items-center justify-center text-current")}
    >
      <Check className="h-4 w-4" strokeWidth={2.5} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export { Checkbox }
